export default "__VITE_ASSET__amu1gnHi__"